// Central brand configuration - single source of truth
export const BRAND = {
  name: "Alessandro Costantino",
  company: "DSB Coaching",
  tagline: "Coaching in der Berufswelt",
  address: {
    street: "Stresemannstr. 14",
    city: "42719 Solingen",
    country: "Deutschland",
  },
  phone: "0212 / 23 29 88 77",
  phoneHref: "tel:+4921223298877",
  email: "info@coach-sg.de",
  logos: {
    main: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/1v6xr8sh_file_1776611936589.jpeg",
    icon: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/ab2ebxsw_file_1776611931096.jpeg",
  },
  photos: {
    portrait: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/cc0e0j4t_Alex_ganz_BeraterstyleDSB.jpeg",
    coaching: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/9dgkqc6b_Adi%26Alex_Beraterstyle.jpeg",
    stage: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/b7u12ld8_IMG_8550.jpeg",
  },
};

export const NAV_LINKS = [
  { label: "Start", to: "/" },
  { label: "Über mich", to: "/ueber-mich" },
  { label: "Leistungen", to: "/leistungen" },
  { label: "Zielgruppen", to: "/zielgruppen" },
  { label: "Kontakt", to: "/kontakt" },
];

export const SERVICES = [
  {
    slug: "azubi-coaching",
    code: "01",
    title: "Azubi-Coaching",
    excerpt: "Orientierung, Selbstvertrauen und Arbeitshaltung für einen starken Start in die Ausbildung.",
    outcomes: ["Klare berufliche Richtung", "Selbstbewusster Auftritt", "Professionelle Arbeitshaltung"],
  },
  {
    slug: "berufseinsteiger",
    code: "02",
    title: "Coaching für Berufseinsteiger",
    excerpt: "Der Übergang von Ausbildung oder Studium in den ersten Job – strukturiert, souverän, mit Substanz.",
    outcomes: ["Sicherer Einstieg", "Klare Prioritäten", "Wirksame Kommunikation"],
  },
  {
    slug: "karriere-coaching",
    code: "03",
    title: "Karriere- & Entwicklungscoaching",
    excerpt: "Wenn die nächste Stufe ansteht: Positionierung, Profil und Strategie für den nächsten Schritt.",
    outcomes: ["Präzise Positionierung", "Gezielte Entscheidungen", "Fundierter Karriereplan"],
  },
  {
    slug: "fachkraefte",
    code: "04",
    title: "Coaching für Fachkräfte",
    excerpt: "Fachliche Stärke in Wirkung übersetzen – für mehr Sichtbarkeit und Einfluss im Unternehmen.",
    outcomes: ["Sichtbare Expertise", "Stärkere Rolle im Team", "Mehr Verantwortung"],
  },
  {
    slug: "fuehrungskraefte",
    code: "05",
    title: "Führungskräfteentwicklung",
    excerpt: "Haltung, Kommunikation und Klarheit für Führung mit Substanz – vom Teamleiter bis zur Geschäftsführung.",
    outcomes: ["Klare Führungsrolle", "Stärkere Teamkultur", "Messbare Entscheidungen"],
  },
  {
    slug: "kommunikation",
    code: "06",
    title: "Kommunikation & Auftreten",
    excerpt: "Präsenz, Sprache und Wirkung – in Meetings, Präsentationen und Verhandlungen.",
    outcomes: ["Souveräner Auftritt", "Klare Sprache", "Verhandlungsstärke"],
  },
];

export const TARGET_GROUPS = [
  {
    slug: "azubis",
    code: "A",
    label: "Azubis",
    kicker: "Orientierung & Start",
    headline: "Einen starken Grundstein legen.",
    description:
      "Die ersten Schritte in der Berufswelt prägen Jahre – oft Jahrzehnte. Wir bauen Haltung, Arbeitsweise und Selbstvertrauen auf, damit aus dem Azubi eine Fachkraft mit Substanz wird.",
    topics: [
      "Umgang mit Ausbildern und Kollegen",
      "Struktur, Zeit & Prüfungsvorbereitung",
      "Selbstorganisation und Motivation",
      "Erste Konflikte souverän lösen",
      "Berufliche Identität und Haltung",
    ],
  },
  {
    slug: "fachkraefte",
    code: "F",
    label: "Fachkräfte",
    kicker: "Wirkung & Entwicklung",
    headline: "Fachliche Exzellenz sichtbar machen.",
    description:
      "Gute Arbeit allein reicht nicht. Für den nächsten Karriereschritt braucht es Kommunikation, Sichtbarkeit und strategisches Denken. Genau hier setzt das Coaching an.",
    topics: [
      "Positionierung im Unternehmen",
      "Überzeugen in Meetings & Präsentationen",
      "Führung ohne Führungsrolle",
      "Gehalts- und Entwicklungsgespräche",
      "Von der Fachkraft zur Schlüsselperson",
    ],
  },
  {
    slug: "fuehrungskraefte",
    code: "L",
    label: "Führungskräfte",
    kicker: "Führung & Verantwortung",
    headline: "Souverän führen – auch in komplexen Phasen.",
    description:
      "Ob erste Führungsrolle, Reorganisation oder Restrukturierung: Führung heißt Entscheidungen treffen, die halten. Ich begleite Führungskräfte bis auf Geschäftsführungs-Ebene.",
    topics: [
      "Strategische Klarheit & Priorisierung",
      "Kommunikation im Management-Team",
      "Veränderungsprozesse sicher führen",
      "Konflikt- & Krisenkommunikation",
      "Rolle, Haltung und Wirksamkeit",
    ],
  },
];

export const FAQS = [
  {
    q: "Für wen ist das Coaching geeignet?",
    a: "Für Menschen, die beruflich etwas bewegen wollen – vom Azubi über Fachkräfte bis hin zur Führungsebene. Entscheidend ist der Wille zur echten Entwicklung, nicht die Position.",
  },
  {
    q: "Wie läuft ein Coaching ab?",
    a: "Nach einem kostenfreien Erstgespräch klären wir Ziele und Rahmen. Dann folgen strukturierte Einheiten – meist 60 bis 90 Minuten – über einen klar definierten Zeitraum. Sie bekommen Werkzeuge, keine Floskeln.",
  },
  {
    q: "Finden die Termine online oder vor Ort statt?",
    a: "Beides ist möglich. Online per sicherem Videocall oder persönlich in Solingen. Für Firmenkunden auch vor Ort im Unternehmen.",
  },
  {
    q: "Wie schnell zeigen sich Ergebnisse?",
    a: "Erste Klarheit entsteht oft schon in den ersten Sitzungen. Nachhaltige Veränderungen in Haltung und Verhalten brauchen mehrere Wochen – mit klaren, messbaren Meilensteinen.",
  },
  {
    q: "Ist das Coaching vertraulich?",
    a: "Absolut. Alle Gespräche unterliegen strikter Vertraulichkeit. Das ist die Grundlage für echte Arbeit an Themen, die wirklich zählen.",
  },
  {
    q: "Arbeiten Sie auch mit Unternehmen?",
    a: "Ja. Neben Einzel-Coachings begleite ich Führungsteams in Entwicklungs-, Veränderungs- und Restrukturierungsphasen. Referenz: Interims-Geschäftsführung Emde Solingen GmbH (2023–2025), EBIT-Wende + 850.000 €, 20 Arbeitsplätze gesichert, erfolgreicher Verkauf.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Alessandro Costantino bringt eine seltene Mischung aus analytischer Klarheit und menschlicher Tiefe mit. Nach wenigen Sitzungen war meine Führungshaltung grundlegend geschärft.",
    author: "Geschäftsführer, Mittelstand",
    role: "Handwerk & Produktion",
  },
  {
    quote:
      "Kein Coaching-Geschwätz. Er geht direkt an den Kern, stellt die richtigen Fragen und fordert Ergebnisse. Genau das, was ich brauchte.",
    author: "Teamleiterin",
    role: "IT-Dienstleistung",
  },
  {
    quote:
      "Von der Ausbildung bis zur Übernahme in die Fachabteilung – das Coaching hat meinem Sohn einen strukturierten Weg gegeben. Sehr dankbar.",
    author: "Elternteil eines Azubis",
    role: "Berufliche Orientierung",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Erstgespräch",
    description:
      "Unverbindlich, kostenfrei, auf Augenhöhe. Wir klären, wo Sie stehen, was Sie wollen und ob wir zusammenpassen.",
  },
  {
    step: "02",
    title: "Zieldefinition",
    description:
      "Gemeinsam formulieren wir präzise Ziele und Messgrößen. Kein beliebiges Arbeiten – sondern fokussierte Ergebnisse.",
  },
  {
    step: "03",
    title: "Coaching-Zyklus",
    description:
      "Strukturierte Sitzungen mit klaren Werkzeugen, Aufgaben zwischen den Terminen und regelmäßiger Standortbestimmung.",
  },
  {
    step: "04",
    title: "Transfer & Wirkung",
    description:
      "Die Ergebnisse werden im beruflichen Alltag umgesetzt. Sichtbar, messbar, nachhaltig.",
  },
];

export const HEADLINE_MAIN =
  "Klarheit. Haltung. Wirksamkeit.";
export const HEADLINE_SUB =
  "Premium-Coaching für Menschen, die in der Berufswelt Verantwortung übernehmen – vom Azubi bis zur Geschäftsführung.";

// Unternehmerische Mandate — aktuelle Rollen & Referenzen
export const COMPANIES = [
  {
    name: "Emde Solingen GmbH",
    role: "Interims-Geschäftsführer",
    period: "Ende 2023 – Ende 2025",
    kpi: "EBIT + 850.000 €",
    type: "Sanierung & Verkauf",
    description:
      "Mandat zur Sanierung und Neuausrichtung. Das Unternehmen wurde vor der Insolvenz gerettet, 20 Arbeitsplätze gesichert, strategisch neu aufgestellt und erfolgreich verkauft.",
    url: "https://www.emde-sg.de",
    logo: "/logos/emde.svg",
    logoBg: "dark",
    status: "closed",
  },
  {
    name: "DSB Business Solutions GmbH",
    role: "Geschäftsführer, Gesellschafter & Gründer",
    period: "Seit 2018",
    kpi: "Eigenes Unternehmen",
    type: "Datenschutz, Compliance, Awareness",
    description:
      "Gegründet und geführt als eigene unternehmerische Plattform für externen Datenschutz, Compliance und Awareness-Beratung mittelständischer Unternehmen.",
    url: "https://www.dsb-deutschland.org",
    logo: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/g3fqjhpa_dsb-new.png",
    logoBg: "transparent",
    status: "active",
  },
  {
    name: "AtoB Objektservice GmbH",
    role: "Geschäftsführer (im Auftrag gegründet)",
    period: "Seit 2026",
    kpi: "Aufbaumandat",
    type: "Facility & Objektservice",
    description:
      "Im Auftrag gegründet und aktuell als Geschäftsführer in der Aufbau- und Wachstumsphase verantwortlich.",
    url: "https://www.atob-objektservice.de",
    logo: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/u5vpqmoh_AtoB_Objektservice.png",
    logoBg: "transparent",
    status: "active",
  },
  {
    name: "AtoB Logistic Solutions GmbH",
    role: "Im Auftrag gegründet & übergeben",
    period: "Gründung & Übergabe",
    kpi: "Start-up-Mandat",
    type: "Logistik",
    description:
      "Im Auftrag gegründet, aufgebaut und nach definierter Anlaufphase an die Eigentümer übergeben.",
    url: "https://www.atob-logistics.de",
    logo: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/vmgnyrvh_AtoB_LogisticSolutions.svg",
    logoBg: "light",
    status: "transferred",
  },
];

// Detaillierter Werdegang
export const CAREER = [
  {
    period: "12/2023 – 12/2025",
    role: "Interims-Geschäftsführer",
    org: "Emde Solingen GmbH",
    bullets: [
      "Change-Management nach Lewin (Unfreeze · Change · Refreeze)",
      "Sanierung & Konsolidierung aus Krisenlage",
      "Erfolgreicher Verkauf des Unternehmens",
      "20 Arbeitsplätze gesichert · EBIT + 850 T€",
    ],
  },
  {
    period: "Seit 05/2018",
    role: "Geschäftsführer & Gesellschafter",
    org: "DSB Business Solutions GmbH (Gründer)",
    bullets: [
      "Aufbau der eigenen Beratungs- und Coaching-Plattform",
      "Externer Datenschutzbeauftragter in mittelständischen Unternehmen",
      "Awareness- und Compliance-Programme",
    ],
  },
  {
    period: "05/2022 – 10/2023",
    role: "Senior Projektbeauftragter – Awareness-Tool",
    org: "IT-Sicherheit · SaaS",
    bullets: [
      "Produkt­weiter­entwicklung eines Awareness-Tools",
      "Live-Produktvorstellungen auf Fachmessen",
      "Abschluss von Partnerverträgen mit Branchenprimus",
    ],
  },
  {
    period: "01/2021 – 12/2021",
    role: "Senior Projektbeauftragter – Datenschutzmanagement",
    org: "Österreichisches Bauunternehmen mit DE-Töchtern",
    bullets: [
      "Konzeption eines einheitlichen Datenschutzmanagements",
      "Roll-out in internationaler Gruppenstruktur",
    ],
  },
  {
    period: "02/2015 – 12/2021",
    role: "Geschäftsführer",
    org: "Integrationsunternehmen (Facility Service)",
    bullets: [
      "Aufbau von 20 auf 40 Mitarbeitende",
      "Umsatz: 3,2 Mio €",
      "Verantwortung für Strategie, Finanzen, HR",
    ],
  },
  {
    period: "Seit 09/2020",
    role: "Awareness-Experte",
    org: "KMU · DACH-Region",
    bullets: [
      "Analyse des IT-Sicherheits-Ist-Zustands",
      "Schwachstellenbehebung und Mitarbeitenden-Schulungen",
    ],
  },
  {
    period: "Seit 09/2014",
    role: "Dozent",
    org: "Datenschutz- und Arbeitsrecht",
    bullets: [
      "Unterricht angehender Personalmanager:innen",
      "Prüfungsvorbereitung in Schlüsselbereichen",
    ],
  },
  {
    period: "09/2012 – 01/2015",
    role: "Leiter der Akademie · Assistent der GF",
    org: "fourtexx GmbH",
    bullets: [
      "Aufbau eines HR-Schulungskonzepts",
      "Implementierung und Betrieb der Akademie",
    ],
  },
  {
    period: "Seit 04/2013",
    role: "Ausschuss-Mitglied",
    org: "IHK (HR & Office)",
    bullets: [
      "Mitarbeit in verschiedenen IHK-Ausschüssen",
      "Beitrag zu Branchenstandards und Best Practices",
    ],
  },
];

export const EDUCATION = [
  {
    year: "2009 – 2013",
    title: "LL.B. Bachelor of Laws",
    place: "Rheinische Fachhochschule Köln",
  },
  { year: "Zertifiziert", title: "Datenschutzbeauftragter (TÜV)", place: "TÜV" },
  { year: "IHK", title: "Personalfachkaufmann", place: "IHK" },
  { year: "IHK", title: "Ausbilder der Ausbilder (AdA)", place: "IHK" },
  { year: "IHK", title: "Kaufmann für Bürokommunikation", place: "IHK" },
];

export const LANGUAGES = [
  { name: "Deutsch", level: "Muttersprache" },
  { name: "Englisch", level: "Verhandlungssicher" },
  { name: "Italienisch", level: "Umgangssprachlich" },
];

export const INDUSTRIES = [
  "Industrie & Metallverarbeitung",
  "Mittelstand & Familienunternehmen",
  "IT & Informationssicherheit",
  "Gesundheitswesen",
  "Non-Profit & Integrationsbetriebe",
  "Bau- und Baunebengewerbe",
  "Handel & Dienstleistung",
  "Bundesministerium & öffentliche Hand",
];

// Presse & Medien
export const PRESS_LOGOS = {
  awo: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/lgg30ttz_348241376_816601623166371_3865238857375194239_n.jpg",
};

export const COMPANY_LOGOS = {
  dsb: "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/g3fqjhpa_dsb-new.png",
  atob_objekt:
    "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/u5vpqmoh_AtoB_Objektservice.png",
  atob_logistic:
    "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/vmgnyrvh_AtoB_LogisticSolutions.svg",
};

export const PRESS_ARTICLE = {
  outlet: "BILD Deutschland",
  date: "11. März 2020",
  headline: "»Für diesen Chef ist ein Handicap kein Hindernis!«",
  intro:
    "Porträt über die AWO Service & Integration GmbH in Solingen – 20 Mitarbeitende, davon 8 mit schwerer, meist körperlicher Behinderung. Entrümpelungen, Umzüge, Hausmeister- und Gärtnerarbeiten für bedürftige Menschen.",
  quote:
    "Wir sind vielleicht nicht besser als andere, aber auch nicht schlechter. Und: Bei uns zählt die Komponente Mensch!",
  humorLine:
    "Ja, auch das ist passiert. Einmal in der BILD gelandet – bei einer Sache, auf die ich bis heute stolz bin.",
  image:
    "https://customer-assets.emergentagent.com/job_alessandro-coaching/artifacts/x7ky302g_alex_bild.JPG",
};

// Weitere Buchungsoptionen über das klassische Coaching hinaus
export const ENGAGEMENTS = [
  {
    slug: "interim-gf",
    code: "I",
    label: "Interim-Geschäftsführung",
    kicker: "Executive · Sanierung · Wachstum",
    headline: "Führung auf Zeit. Ergebnisse auf Dauer.",
    description:
      "Als Interims-Geschäftsführer übernehme ich operative Gesamt­verantwortung in Sanierungs-, Übergangs- oder Wachstumsphasen. Referenz: Emde Solingen GmbH – in 24 Monaten aus der Krise in den erfolgreichen Verkauf geführt, EBIT-Wende + 850.000 €, 20 Arbeitsplätze gesichert.",
    bullets: [
      "Sanierungs- und Krisenführung",
      "Strategische Neuausrichtung & Change-Management",
      "Stakeholder-, Banken- & Gesellschafter-Kommunikation",
      "Vorbereitung & Begleitung von M&A / Unternehmensverkauf",
    ],
    cta: "Mandat anfragen",
  },
  {
    slug: "projektmandate",
    code: "P",
    label: "Projektmandate",
    kicker: "Spezialprojekte · Transformation",
    headline: "Projekte, die nicht schief gehen dürfen.",
    description:
      "Ob Datenschutz-Rollout in internationalen Gruppen, Aufbau einer HR-Akademie, Markteinführung eines Awareness-Tools oder Gründung einer neuen GmbH im Auftrag: ich übernehme Projekte mit Gesamtverantwortung – vom Konzept über die Umsetzung bis zur sauberen Übergabe.",
    bullets: [
      "Unternehmens­gründung im Auftrag (u. a. AtoB Objektservice, AtoB Logistic Solutions)",
      "Restrukturierungs- und Transformationsprojekte",
      "Datenschutz- und Compliance-Programme (TÜV-DSB, LL.B.)",
      "Produkt- & Markteinführungen inkl. Partnerverträge",
    ],
    cta: "Projekt anfragen",
  },
  {
    slug: "speaker",
    code: "S",
    label: "Speaker & Fachvorträge",
    kicker: "Keynotes · Panels · Business-Events",
    headline: "Ein Vortrag, an den sich die Teilnehmer erinnern.",
    description:
      "Ich spreche auf Fachveranstaltungen, Branchen-Foren, Partner-Tagungen und internen Leadership-Events. Referenzen u. a.: IT-Sicherheitsforum Synaxon Akademie (»Dauerhaft Geld verdienen am Beispiel Managed Phishing«). Sprachen: Deutsch (Muttersprache), Englisch (verhandlungssicher), Italienisch.",
    bullets: [
      "Leadership & Führung in Krisenphasen",
      "Cybersecurity & Awareness für den Mittelstand",
      "Datenschutz & Compliance aus Geschäftsführungs-Sicht",
      "Karriere, Entwicklung und Arbeitshaltung",
    ],
    cta: "Speaker anfragen",
  },
  {
    slug: "messen",
    code: "M",
    label: "Messen & Events",
    kicker: "Bühnen · Produkt · Livedemo",
    headline: "Produkte und Themen, die auf der Bühne wirken.",
    description:
      "Live-Produktvorstellungen, Bühnen-Interviews, Expert-Panels und Publikums­moderation. Ich bringe Themen technisch präzise und zugleich verständlich auf die Messe-Bühne – mit einem unternehmerischen Blick für die Story hinter dem Produkt.",
    bullets: [
      "Produktlaunches & Live-Demos auf Fachmessen",
      "Panel- und Bühnenmoderation",
      "Standgespräche auf Entscheider-Niveau",
      "Partner- und Händler-Tagungen",
    ],
    cta: "Buchung anfragen",
  },
];
